import { ConditionOutreachType } from './types';

export const getNodesToBeDeleted = (
  start: string,
  set: string[],
  map: Map<string, Array<ConditionOutreachType>>
) => {
  const neighborNodes = map.get(start);
  if (neighborNodes) {
    for (const neighborNode of neighborNodes) {
      set.push(neighborNode.conditionOutreach.currentNode);
      for (const outreach of neighborNode.conditionOutreach.outreach) {
        getNodesToBeDeleted(
          `${neighborNode.conditionOutreach.currentNode}-${outreach.outreachId}`,
          set,
          map
        );
      }
    }
  }
};

export const getTimesForOutreach = (days: number) =>
  Array.from({ length: days }, (_, i) => {
    if (i === 0) {
      return { id: '0', label: 'T', value: '0' };
    }
    return {
      id: i.toString(),
      label: `T+${i}`,
      value: i.toString(),
    };
  });

export function convertMinutesToDaysHoursMinutes(minutes: number): {
  days: number;
  hours: number;
  minutes: number;
} {
  const days: number = Math.floor(minutes / (24 * 60));
  const remainingHours: number = Math.floor((minutes % (24 * 60)) / 60);
  const remainingMinutes: number = minutes % 60;

  return { days, hours: remainingHours, minutes: remainingMinutes };
}

export const splitTimeSlotToMinutes = (slot = '') =>
  (parseInt(slot.split(':')?.[1]) || 0) +
  (parseInt(slot.split(':')?.[0]) || 0) * 60;
